// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-group {
  background-color: var(--background-light);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  padding: 4px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.checkbox-item:hover {
  background-color: var(--surface-light);
}

.checkbox-item + .checkbox-item {
  border-top: 1px solid var(--border-light);
}

.checkbox-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border: 1px solid var(--border-light);
  border-radius: 4px;
  cursor: pointer;
  accent-color: var(--primary);
}

.checkbox-item label {
  flex: 1;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  user-select: none;
}

.checkbox-item--disabled {
  opacity: 0.5;
}

.info-banner--save-options {
  margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/SaveOptions/SaveOptions.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".checkbox-group {\n  background-color: var(--background-light);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.checkbox-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.checkbox-item:hover {\n  background-color: var(--surface-light);\n}\n\n.checkbox-item + .checkbox-item {\n  border-top: 1px solid var(--border-light);\n}\n\n.checkbox-item input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  cursor: pointer;\n  accent-color: var(--primary);\n}\n\n.checkbox-item label {\n  flex: 1;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  user-select: none;\n}\n\n.checkbox-item--disabled {\n  opacity: 0.5;\n}\n\n.info-banner--save-options {\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
